import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../sokusai-management.constants';

@Component({
  selector: 'app-sokusai-management-change-password-sent',
  templateUrl: './sokusai-management-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './sokusai-management-change-password-sent.component.css',
  ],
})
export class SokusaiManagementChangePasswordSentComponent implements OnInit {
  email: string | null = null;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
